import * as React        from "react";
import {cx}              from "emotion";
import {useRef,
        useState}        from "react";

import "./contentSectionFieldCreator.scss";
import "../customize-panel.scss";

import {CommentBoxWithCounter}   from "./commentBoxWithCounter";
import {Input}                   from "./input";
import {OfficeSearchField}       from "./officeSearchField";
import {TinyMceField}            from "./tinyMceField";
import {UserSearchField}         from "./userSearchField";
import {SliderCheckbox}          from "@Common/ui-components/slider-checkbox/slider-checkbox";


export const ContentSectionFieldCreator = ({idOrder, data, setUnsavedChanges, companyPrefs}) => {

    const editorRef = useRef([]);

    function createFields(contentField) {

        const [labelValue, setLabelValue] = useState(contentField.displayLabel);
        const [fieldValue, setFieldValue] = useState(contentField.value);
        const [aiTextGenerating, setAiTextGenerating] = useState(false);
        const [ckValue, setCkValue]           = useState(0);
        const [overrideCKValue, setOverrideCKValue] = useState(false);
        const [selectChoice, setSelectChoice] = useState(fieldValue);
        const [alignmentChoice, setAlignmentChoice] = useState(contentField.align);

        const fieldId = contentField.idPrimary;

        function setLabelHandler (data) {
            let curval = data?.target.value;
            setLabelValue(curval);
        }

        function deleteCheckHandler () {
            setCkValue((currVal) => currVal == 0 ? 1 : 0);
        }

        function overrideCheckHandler () {
            if (!overrideCKValue) {
                if( confirm ( 'If you would like to OVERRIDE the\r\ncharacter counter and add additional text,\r\nplease click OK.\r\n\r\nYour proof will display EXACTLY how your text\r\nwill appear.\r\n\r\nNO CREDITS WILL BE GIVEN TOWARDS ORDERS\r\nTHAT WERE PLACED WITH ADDITIONAL TEXT.\r\n' ) ) {
                    setOverrideCKValue((prevVal) =>  !prevVal);
                }
            } else if (fieldValue.length > contentField.maxLength && contentField.idDisplayStyle !== 4 ) {
                    if ( confirm(`Override will be deactivated. Text in field "${contentField.displayLabel}" will be cut off to ${contentField.maxLength} characters`) ) {
                        setOverrideCKValue((prevVal) =>  !prevVal);
                    }
            } else if (contentField.idDisplayStyle === 4) {
                let find = [
                    '<p>',
                    '</p>',
                    '\\i',
                    '\\i',
                    '\\b',
                    '\\b',
                    ' ',
                    '\\u',
                    '\\u',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                ];

                function findReplace(find, string) {
                    for (let i = 0; i < find.length; i++) {
                        string = string.replaceAll(find[i], "");
                    }
                    return string;
                }

                let stringVal = findReplace(find, fieldValue);

                if (stringVal.length > contentField.maxLength) {
                    if ( confirm(`Override will be deactivated. Text in field "${contentField.displayLabel}" will be cut off to ${contentField.maxLength} characters`) ) {
                        setOverrideCKValue((prevVal) =>  !prevVal);
                    }
                } else {
                    setOverrideCKValue((prevVal) =>  !prevVal);
                }
            } else {
                setOverrideCKValue((prevVal) =>  !prevVal);
            }
        }

        const replaceStr = (str) => {
            return str.replace( /(<([^>]+)>)/ig, '');
        }

        function changeHandler(event) {
            setUnsavedChanges();
            setFieldValue(event.target.value);
        }

        return (
            <div className="content-section-field-creator-46d" key={contentField.idPrimary}>
                <div className={contentField.idDisplayStyle == 2 ? "edit-label-and-input-instance" : "content-field-instance"}>
                    {contentField.idDisplayStyle == 2 && (
                        <div className="check">
                            <Input
                                inputField={contentField}
                                inputType="checkbox"
                                fieldValue={ckValue}
                                hidden={true}
                                xdQaType="checkbox"
                                extraInfo={{"data-multiPartField": "deleteField"}}
                            />
                            <SliderCheckbox
                                value={!ckValue}
                                onChange={deleteCheckHandler}
                                dark={true}
                            />
                        </div>
                    )}
                    <div className="content-label-div">
                    {contentField.idDisplayStyle == 2 && (
                            <Input
                                inputField={contentField}
                                fieldValue={labelValue}
                                changeHandler={setLabelHandler.bind(this)}
                                readOnly={!!ckValue}
                                extraInfo={{"data-multipartfield": "label"}}
                                xdQaType="label"
                            />
                    )}

                    {contentField.idDisplayStyle != 6 && contentField.idDisplayStyle != 2  &&
                    <div xd-qa-type="label" xd-qa-name={contentField.displayLabel} >{contentField.displayLabel}</div>}
                    </div>
                    <div className="content-input-div">
                        {contentField.idDisplayStyle == 4 ?
                            <TinyMceField
                                idOrder={idOrder}
                                fieldId={fieldId}
                                fieldValue={fieldValue}
                                setFieldValue={setFieldValue}
                                fieldData={contentField}
                                editorRef={editorRef}
                                aiTextGenerating={aiTextGenerating}
                                setAiTextGenerating={setAiTextGenerating}
                                companyPrefs={companyPrefs}
                                replaceStr={replaceStr}
                            />
                        : contentField.idDisplayStyle == 3 ?
                            <select defaultValue="" name={contentField.fieldKey} value={selectChoice} onChange={() => setSelectChoice(this.value)} data-fieldname={contentField.displayLabel} xd-qa-type="dropdown" xd-qa-name={"order_data["+contentField.fieldKey+"][data]"}>
                                <option value="" xd-qa-type="dropdown_item" xd-qa-name="default">
                                    - Select -
                                </option>
                                {
                                    JSON.parse(contentField.defaultValue)?.map((value) =>
                                        <option key={value} value={value.trim()} xd-qa-type="dropdown_item" xd-qa-name={value}>
                                            {value}
                                        </option>
                                    )
                                }
                            </select>
                        : contentField.idDisplayStyle == 2 ?
                            <Input
                                inputField={contentField}
                                dataFieldName={labelValue}
                                fieldValue={fieldValue}
                                changeHandler={changeHandler}
                                readOnly={!!ckValue}
                                extraInfo={{"data-multipartfield": "data"}}
                            />
                        : contentField.idDisplayStyle == 6 ?
                            <Input
                                inputField={contentField}
                                inputFieldName={contentField.fieldKey + "hidden"}
                                inputType="hidden"
                                fieldValue={fieldValue}
                                xdQaType="hidden"
                            />
                        : contentField.idDisplayStyle == 11 ?
                            <CommentBoxWithCounter
                                idOrder={idOrder}
                                fieldData={contentField}
                                fieldValue={fieldValue}
                                setFieldValue={setFieldValue}
                                enableLimitOverride={contentField.enableLimitOverride}
                                aiTextGenerating={aiTextGenerating}
                                setAiTextGenerating={setAiTextGenerating}
                                companyPrefs={companyPrefs}
                                replaceStr={replaceStr}
                            />
                        :
                            <Input
                                inputField={contentField}
                                fieldValue={fieldValue}
                                changeHandler={changeHandler}
                                readOnly={!contentField.isEditable || contentField.idDisplayStyle == 7}
                            />
                        }
                    </div>
                </div>
                {contentField.fieldKey === "field_1" && contentField.idDisplayStyle == 1 &&
                    <div className={"content-field-instance"}>
                        <div className="content-label-div">
                            <div xd-qa-type="label" xd-qa-name={"Align " + contentField.displayLabel} >{"Align " + contentField.displayLabel}</div>
                        </div>
                        <div className="content-input-div">
                            <select className="form-control"
                                value={alignmentChoice ?? ""}
                                name="align_field_1"
                                data-fieldname={contentField.displayLabel}
                                xd-qa-type="dropdown"
                                xd-qa-name="Align Field 1"
                                onChange={(e) => setAlignmentChoice(e.target.value)}
                            >
                                <option key="<*L>" value="&lt;*L&gt;" xd-qa-type="dropdown_item" xd-qa-name="Left">Left</option>
                                <option key="<*C>" value="&lt;*C&gt;" xd-qa-type="dropdown_item" xd-qa-name="Center">Center</option>
                                <option key="<*R>" value="&lt;*R&gt;" xd-qa-type="dropdown_item" xd-qa-name="Right">Right</option>
                                <option key="<*J>" value="&lt;*J&gt;" xd-qa-type="dropdown_item" xd-qa-name="Justify">Justify</option>
                            </select>
                        </div>
                    </div>
                }
                {contentField.idDisplayStyle == 9 &&
                    <OfficeSearchField
                        onlyOffice={true}
                        labelname={contentField.displayLabel}
                        value={fieldValue}
                        xdQAType="text_field"
                        xdQAValue={contentField.fieldKey}
                        data = {data}
                        contentGroup={contentField.contentGroup}
                        displayGroup={contentField.displayGroup}
                    />
                }
                {contentField.idDisplayStyle == 8 &&
                <UserSearchField
                    labelname={contentField.displayLabel}
                    value={fieldValue}
                    xdQAType="text_field"
                    xdQAValue={contentField.fieldKey}
                    data={data}
                    contentGroup={contentField.contentGroup}
                    displayGroup={contentField.displayGroup}
                />
                }
            </div>
        )
    }

    return data.map(createFields);

};